// extracted by mini-css-extract-plugin
export default {"container":"dZ_xZ","checked":"AyNcq","disabled":"zIhFs","input":"zQimH"};